import { NextPage } from 'next';
import { NextSeo } from 'next-seo';
import { StaticImageData } from 'next/image';
import {
  Container,
  FeatureList,
  Footer,
  Header,
  Main,
  RankingItems,
  TabMenu,
  withLayout,
} from '../../components';
import { useFeatureNamePlans, useTellers } from '../../hooks';
import type { CommonFeatureSSRProps } from '../../server/features/commonFeatureServerSideProps';

type FeatureNamePageConfig = {
  slug: string;
  featureName: string;
  title: string;
  description: string;
  ogImageUrl: string;
  heroImage: StaticImageData;
};

export const createFeatureNamePage = (
  config: FeatureNamePageConfig,
): NextPage<CommonFeatureSSRProps> => {
  const Page: NextPage<CommonFeatureSSRProps> = (props) => {
    const tellers = useTellers(props);
    const { plans } = useFeatureNamePlans({
      ...props,
      featureName: config.featureName,
    });

    const tellerAndPlan = plans
      .map((plan) => ({
        teller: tellers.find((teller) => teller.id === plan.tellerId),
        plan,
      }))
      .filter((x) => x.teller)
      .sort((a, b) => b.teller.reviewsCount - a.teller.reviewsCount);

    const items: RankingItems = {
      type: 'plan',
      plans: tellerAndPlan,
    };

    return withLayout(
      <Container>
        <NextSeo
          title={config.title}
          openGraph={{
            title: config.title,
            description: config.description,
            url: `https://raysee.jp/features/${config.slug}`,
            type: 'article',
            images: [
              {
                url: config.ogImageUrl,
                alt: 'raysee',
              },
            ],
          }}
        />
        <Header />
        <Main>
          <FeatureList
            title={config.title}
            description={config.description}
            imageUrl={config.heroImage}
            style="none"
            items={items}
            displayType="chat"
            isInfinite
          />
          <Footer />
        </Main>
        <TabMenu />
      </Container>,
    );
  };

  return Page;
};
